export default __webpack_public_path__ + "static/media/loop.2d2dd800.svg";